const styles = theme => ({
  container: {
    width: '100%',
    height: 'auto',
    backgroundColor: '#F2F4F7',
    webkitBackgroundSize: 'cover',
    mozBackgroundSize: 'cover',
    oBackgroundSize: 'cover',
    backgroundSize: 'cover'
  },
  typography: {
    height: '175px',
    width: '35%',
    fontFamily: 'Univia Pro',
    fontSize: '72px',
    fontWeight: '900',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '-2px',
    color: '#ffffff',
    paddingTop: '20%',
    marginLeft: '8%'
  },
  title: {
    marginTop: '90px',
    marginBottom: 0,
    fontSize: '32px',
    lineHeight: '64px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#015099'
  },
  description: {
    marginTop: '15px',
    alignSelf: 'center',
    fontSize: '20px',
    lineHeight: '24px',
    textAlign: 'center',
    color: '#3A3A3A',
    paddingInline: '10px'
  },
  intro: {
    display: 'flex',
    flexFlow: 'column wrap',
    justifyContent: 'center'
  },
  body: {
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '0% 10% 0% 10%'
  }

});

export default styles;

